import { render, staticRenderFns } from "./SignUpPage.vue?vue&type=template&id=56c566fa&scoped=true"
import script from "./SignUpPage.vue?vue&type=script&lang=ts"
export * from "./SignUpPage.vue?vue&type=script&lang=ts"
import style0 from "./SignUpPage.vue?vue&type=style&index=0&id=56c566fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c566fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56c566fa')) {
      api.createRecord('56c566fa', component.options)
    } else {
      api.reload('56c566fa', component.options)
    }
    module.hot.accept("./SignUpPage.vue?vue&type=template&id=56c566fa&scoped=true", function () {
      api.rerender('56c566fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/auth/SignUpPage.vue"
export default component.exports